import { Reveal, Overline } from "./Reveal";
import { DESTINATIONS } from "./data";
import { Placeholder } from "./Placeholder";
import { MapPin } from "lucide-react";
import aerialImg from "@/assets/aerial.webp";
import frontImg from "@/assets/exterior_front.jpg";

export const Location = () => (
  <section id="location" data-testid="location-section" className="py-24 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-12 gap-4 md:gap-6 mb-16">
        <Reveal className="md:col-span-8">
          <Placeholder label="Chirton, nestled in the Pewsey Vale" src={aerialImg} className="aspect-[16/10] md:aspect-auto md:h-full w-full" parallax testId="location-aerial-placeholder" />
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.1}>
          <Placeholder label="The Old Pub, Chirton" src={frontImg} className="aspect-[4/5] md:aspect-auto md:h-full w-full" parallax testId="location-front-placeholder" />
        </Reveal>
      </div>
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>Discover Wiltshire</Overline>
            <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
              In the heart of the countryside
            </h2>
            <p className="font-sans text-textMuted leading-relaxed mt-8">
              An excellent base for exploring some of England's most iconic destinations. Chirton offers the perfect balance of peace and accessibility — whether you're here for history, walking, photography, cycling, business or a relaxing weekend away.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="grid sm:grid-cols-2 gap-x-12 border-t border-line/60">
            {DESTINATIONS.map((d, i) => (
              <Reveal key={d.name} delay={Math.min(i * 0.04, 0.3)} y={20}>
                <div
                  data-testid={`destination-${i}`}
                  className="flex items-start gap-4 py-6 border-b border-line/60 group"
                >
                  <MapPin className="w-4 h-4 text-primary/60 mt-1.5 group-hover:text-primary transition-colors" strokeWidth={1.5} />
                  <div>
                    <h3 className="font-serif text-2xl text-textMain group-hover:text-primary transition-colors duration-400">
                      {d.name}
                    </h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted">
                      {d.note}
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
